import { motion } from 'motion/react'
import { Link } from 'react-router'

const freeFeatures = [
	'First episode completely free',
	'Full access to Noise Reduction, Compression, and EQ',
	'No credit card required',
]

const founderFeatures = [
	{ text: 'Unlimited episode processing' },
	{
		text: 'Bonus: Live weekly audio engineering mentorship',
		note: 'First 25 sign-ups only',
	},
	{
		text: 'Bonus: Featured spot in our newsletter & homepage for a shout-out',
	},
]

export default function LandingFounderPricing() {
	return (
		<section className="relative px-6 py-24 md:py-32" id="founding-offer">
			<div className="mx-auto max-w-5xl">
				<div className="mb-16 text-center">
					<h2 className="text-foreground mb-4 text-4xl font-extrabold tracking-tight md:text-5xl">
						Become a{' '}
						<span className="bg-gradient-to-r from-indigo-400 to-purple-400 bg-clip-text text-transparent">
							Founding Creator
						</span>
					</h2>
					<p className="text-base-content/70 mx-auto max-w-xl text-lg md:text-xl">
						Get professional audio for the price of a cup of coffee.
					</p>
				</div>

				<div className="grid gap-8 md:grid-cols-2 md:items-stretch">
					{/* Column 1: Free trial */}
					<div className="border-foreground/20 bg-background/50 flex flex-col rounded-3xl border p-8 backdrop-blur-sm transition-all duration-300 hover:border-indigo-400/50 hover:shadow-2xl hover:shadow-indigo-500/20">
						<h3 className="text-foreground text-2xl font-bold md:text-3xl">
							Test the Sound
						</h3>
						<div className="mt-4 mb-6">
							<span className="text-foreground text-5xl font-extrabold">
								$0
							</span>
						</div>
						<ul className="text-base-content/80 mb-8 flex-1 space-y-4">
							{freeFeatures.map((feature) => (
								<li key={feature} className="flex items-start gap-3">
									<span className="mt-1 text-indigo-400">✓</span>
									<span>{feature}</span>
								</li>
							))}
						</ul>
						<Link
							to="/editor"
							className="border-foreground/30 text-foreground block w-full rounded-full border-2 px-6 py-3 text-center font-bold backdrop-blur-sm transition-all duration-300 hover:scale-105 hover:border-indigo-400"
						>
							Process Your First Episode
						</Link>
					</div>

					{/* Column 2: Founding member — highlighted */}
					<motion.div
						initial={{ opacity: 0, y: 16 }}
						whileInView={{ opacity: 1, y: 0 }}
						viewport={{ once: true, margin: '-80px' }}
						transition={{ duration: 0.6 }}
						className="relative flex flex-col rounded-3xl border-2 border-indigo-400/60 bg-gradient-to-br from-indigo-500/20 to-purple-500/20 p-8 shadow-2xl shadow-indigo-500/20 md:scale-105"
					>
						<div className="absolute -top-4 left-1/2 -translate-x-1/2 rounded-full bg-gradient-to-r from-indigo-500 to-purple-600 px-4 py-1 text-sm font-bold whitespace-nowrap text-white shadow-lg">
							Founding Member
						</div>
						<h3 className="text-foreground text-2xl font-bold md:text-3xl">
							Lifetime Founder&rsquo;s Rate
						</h3>
						<div className="mt-4 mb-2 flex items-baseline gap-2">
							<span className="text-foreground text-5xl font-extrabold">
								$5
							</span>
							<span className="text-base-content/70 text-lg">/month</span>
						</div>
						<p className="text-base-content/60 mb-6 text-sm">
							Locked in forever — will retail for{' '}
							<span className="line-through">$19/mo</span>
						</p>
						<ul className="text-base-content/80 mb-8 flex-1 space-y-4">
							{founderFeatures.map((feature) => (
								<li key={feature.text} className="flex items-start gap-3">
									<span className="mt-1 text-indigo-400">✓</span>
									<span>
										{feature.text}
										{feature.note && (
											<span className="ml-1 font-semibold text-indigo-400">
												({feature.note})
											</span>
										)}
									</span>
								</li>
							))}
						</ul>
						<Link
							to="/signup"
							className="block w-full rounded-full bg-gradient-to-r from-indigo-500 to-purple-600 px-6 py-3 text-center font-bold text-white shadow-lg shadow-indigo-500/50 transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-indigo-500/60"
						>
							Claim Your Founder&rsquo;s Slot &amp; Mentorship
						</Link>
					</motion.div>
				</div>
			</div>
		</section>
	)
}
